import App from './App.svelte';
import './shared_components/Header.svelte';
import HeaderCopy from './shared_components/HeaderCopy.svelte';
import Footer from './shared_components/Footer.svelte';
const header = new HeaderCopy({
    target: document.getElementById('header'),
});
const app = new App({
    target: document.getElementById('root'),
});
const footer = new Footer({
    target: document.getElementById('footer'),
});
export default app;
